<template>
  <!-- viewBox="0 0 16 16" -->
  <path
    d="M4 9C3.44772 9 3 8.55228 3 8C3 7.44772 3.44772 7 4 7L12 7C12.5523 7 13 7.44771 13 8C13 8.55228 12.5523 9 12 9L4 9Z"
    fill="currentColor"
  />
</template>
